export enum ActionFeedback {
    SUCCESS = "SUCCESS", ERROR = "ERROR", DELETED = "DELETED"
}